export default "__VITE_ASSET__KSB070T6__"